<template>
  <div>
    <navigation-bar>
      <span slot="content">个人信息</span>
    </navigation-bar>
    <div>
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>英文姓</p>
          </div>
          <div class="weui-cell__ft">{{user.lastname}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>英文名</p>
          </div>
          <div class="weui-cell__ft">{{user.firstname}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>中文姓</p>
          </div>
          <div class="weui-cell__ft">{{user.chineseLastname}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>中文名</p>
          </div>
          <div class="weui-cell__ft">{{user.chinesename}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>护照号</p>
          </div>
          <div class="weui-cell__ft">{{user.passID}}</div>
        </div>
      </div>

      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>手机</p>
          </div>
          <div class="weui-cell__ft">{{user.telephone}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>邮箱</p>
          </div>
          <div class="weui-cell__ft">{{user.email}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
  import NavigationBar from '../components/NavigationBar.vue'
  export default{
    computed: {
      user () {
        return this.$store.getters.getUserInfo
      }
    },

    components: {
      NavigationBar
    }
  }
</script>



// WEBPACK FOOTER //
// Profile.vue?3b1682c6